import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { Grid } from '@material-ui/core'
import styled from 'styled-components'

import ItemImagesImport from '../details/images/ItemImages'
import ItemHeadingWithLink from '../details/ItemHeadingWithLink'

export const ModalContainer = styled.div`
  position: relative;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool100};
  width: 96%;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  height: 85vh;
  overflow: hidden auto;

  @media (min-width: 600px) {
    padding: 20px;
    height: fit-content;
    min-height: 530px;
    max-height: 685px;
    overflow-y: auto;
  }

  @media (min-width: 1200px) {
    min-height: 563px;
    width: 80%;
  }
`

export const Container = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 20px 8px;
  border-radius: 5px;

  @media (min-width: 768px) {
    padding: 20px;
  }
`

export const ModalSpinnerContainer = styled.div`
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  padding: 20px;

  & > div {
    position: unset;
  }
`

export const ModalErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
`

export const CloseButton = styled(ButtonLink)`
  position: absolute;
  top: 20px;
  right: 40px;
  flex: 0 0 44px;
  height: 44px;
  margin-right: -15px;
  padding: 15px;
  background-color: transparent;
`

export const ItemShortDescription = styled.p`
  padding: 0 25px 25px 0;
  margin: 0;
  width: 90%;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`

export const Heading = styled(ItemHeadingWithLink)`
  .sku {
    color: #52616b;
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    line-height: 14px;
  }
  .item-name {
    color: ${({ theme }) => theme.colors.blue.light400};
    font-size: 26px;
    font-weight: 700;
    line-height: 26px;
  }
  .item-tagline {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #52616b;
    text-transform: uppercase;
    line-height: 16px;
    letter-spacing: 2px;
    margin: 10px 1px;
  }
`

export const HeaderContainer = styled.div`
  display: inline-block;
  width: 90%;
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    flex-direction: row;
  }
`

export const BodyHalfContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 232px;
  min-height: 310px;

  @media (min-width: 600px) {
    width: 50%;
    min-width: 238px;
  }

  @media (min-width: 750px) {
    min-width: 300px;
  }

  @media (min-width: 900px) {
    min-width: 367px;
  }

  .control-header {
    text-transform: uppercase;
    font-size: 12px;
    font-style: normal;
    font-weight: bold;
    -webkit-letter-spacing: 0.06em;
    -moz-letter-spacing: 0.06em;
    -ms-letter-spacing: 0.06em;
    letter-spacing: 0.06em;
    line-height: 14px;
    margin-bottom: 8px;
  }
`

export const ItemImages = styled(ItemImagesImport)`
  background: transparent;
  width: 90%;
  height: auto;
  padding-top: 0;
  padding-left: 0;

  .item-image-container {
    background: ${({ theme }) => theme.colors.coolGray.cool100};
    padding: 0;
  }

  .item-image-previews-container {
    align-self: baseline;
    margin-top: 0;
  }

  .item-image-preview {
    background: ${({ theme }) => theme.colors.coolGray.cool100};
    height: 100%;
    width: 63px;
  }
`
